import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { downloadClaimsThunk, getClaimsByProviderThunk } from './claimsThunk';

import { IState } from 'types/Claims';

const initialState: IState = {
	claims: null,
	change: false,
	pages: 1,
	page: 1,
	search: false,
};

export const getClaims = createAsyncThunk(
	'claims/getClaims',
	getClaimsByProviderThunk,
);

export const downloadClaims = createAsyncThunk(
	'claims/downloadClaims',
	downloadClaimsThunk,
);

const claimsSlice = createSlice({
	name: 'claims',
	initialState,
	reducers: {
		setSearchValue: (
			state: any,
			{ payload }: PayloadAction<{ name: string; value: string }>,
		) => {
			const { name, value } = payload;
			state[name] = value;
		},
		setChangeFalse: state => {
			state.change = false;
		},
		changePage: (state: IState, { payload }: PayloadAction<number>) => {
			state.page = payload;
		},
		resetClaims: () => initialState,
	},
	extraReducers: builder => {
		builder
			.addCase(getClaims.fulfilled, (state, { payload }) => {
				state.claims = payload.claims;
				state.change = true;
				state.pages = payload.pages;
			})
			.addCase(getClaims.rejected, state => {
				state.claims = [];
			});
	},
});

export const { resetClaims, setChangeFalse, changePage, setSearchValue } =
	claimsSlice.actions;
export default claimsSlice.reducer;
